<script lang="ts">
  import { X } from "lucide-svelte";
  import Filter from "$lib/components/filter.svelte";
  import Details from "$lib/components/details/details.svelte";
  import SearchBar from "$lib/components/search-bar.svelte";
  import { searchStore } from "$lib/stores/search.svelte";
  import { stateStore } from "$lib/stores/state.svelte";
  import { Button } from "$lib/components/ui/button";
  import SearchContainer from "./search/search-container.svelte";
  import Categories from "./categories.svelte";

  // User location (consider moving to a store)
  let userLat = $state<number | undefined>(47.497912);
  let userLng = $state<number | undefined>(19.040235);

  async function handleLoadMore() {
    await searchStore.loadMore(userLat, userLng);
  }

  function handleCloseBar() {
    stateStore.activePage = null;
  }
</script>

<div
  class="fixed inset-0 max-w-full sm:max-w-xl space-y-1 pt-12
    transition-all duration-500
    {stateStore.sidebaropen ? 'h-full bg-background/80 pb-12' : 'h-fit'}"
  role="search"
>
  {#if stateStore.sidebaropen}
    <Button class="absolute right-2 top-2" onclick={handleCloseBar}>
      <X />
    </Button>
  {/if}
  <!-- Search Bar -->
  <SearchBar />

  <!-- Content Area -->
  {#if stateStore.sidebaropen}
    <div class="max-h-full overflow-y-auto pb-32">
      {#if stateStore.activePage === "category"}
        <Filter />
      {:else if stateStore.activePage === "filter"}
        <Categories />
      {:else if stateStore.activePage === "search"}
        <SearchContainer />
      {:else if stateStore.activePage === "detail"}
        <Details />
      {/if}
    </div>
  {/if}
</div>
